import React from 'react';
import { FlameIcon, AlertTriangleIcon } from 'lucide-react';
export function UrgencyBar() {
  return <section className="relative overflow-hidden" data-id="element-233">
      {/* Animated fire gradient background */}
      <div className="absolute inset-0 bg-gradient-to-r from-red-900 via-orange-800 to-red-900 animate-urgency-bg" data-id="element-234"></div>
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cmFkaWFsR3JhZGllbnQgaWQ9ImciIGN4PSI1MCUiIGN5PSI1MCUiIHI9IjUwJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmYTUwMCIgc3RvcC1vcGFjaXR5PSIwLjEiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9InRyYW5zcGFyZW50Ii8+PC9yYWRpYWxHcmFkaWVudD48L2RlZnM+PGNpcmNsZSBjeD0iMTAwIiBjeT0iMTAwIiByPSIxMDAiIGZpbGw9InVybCgjZykiLz48L3N2Zz4=')] opacity-30" data-id="element-235"></div>

      {/* Shimmer overlay */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-236">
        <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/5 to-transparent" data-id="element-237"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 py-4 md:py-5" data-id="element-238">
        <div className="flex flex-col items-center gap-3" data-id="element-239">
          {/* Top row */}
          <div className="flex items-center gap-2" data-id="element-240">
            <FlameIcon className="w-5 h-5 text-orange-400 animate-pulse" data-id="element-241" />
            <span className="text-sm md:text-base font-black text-white uppercase tracking-wider" data-id="element-242">
              Promoción por tiempo limitado
            </span>
            <FlameIcon className="w-5 h-5 text-orange-400 animate-pulse" data-id="element-243" />
          </div>

          {/* Progress bar */}
          <div className="w-full max-w-md" data-id="element-244">
            <div className="flex items-center justify-between mb-1.5" data-id="element-245">
              <div className="flex items-center gap-1.5" data-id="element-246">
                <AlertTriangleIcon className="w-3.5 h-3.5 text-yellow-400" data-id="element-247" />
                <span className="text-[11px] font-bold text-yellow-300" data-id="element-248">
                  Cupos disponibles agotándose
                </span>
              </div>
              <span className="text-[11px] font-black text-white bg-red-500/80 px-2 py-0.5 rounded-full" data-id="element-249">
                80% tomados
              </span>
            </div>
            <div className="w-full bg-black/30 rounded-full h-3 overflow-hidden border border-orange-500/30" data-id="element-250">
              <div className="h-full rounded-full relative overflow-hidden" style={{
              width: '80%'
            }} data-id="element-251">
                {/* Fire gradient bar */}
                <div className="absolute inset-0 bg-gradient-to-r from-red-500 via-orange-400 to-yellow-400" data-id="element-252"></div>
                {/* Animated glow pulse */}
                <div className="absolute inset-0 bg-gradient-to-r from-red-500 via-orange-400 to-yellow-400 animate-pulse opacity-60" data-id="element-253"></div>
                {/* Shimmer on bar */}
                <div className="absolute inset-0 overflow-hidden" data-id="element-254">
                  <div className="absolute inset-0 -translate-x-full animate-bar-shimmer bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-255"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom text */}
          <p className="text-xs md:text-sm text-orange-200/90 font-medium text-center" data-id="element-256">
            Últimos cupos a precio promocional — una vez agotados, vuelve al
            precio original.
          </p>
        </div>
      </div>

      {/* Bottom glow line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-400/50 to-transparent" data-id="element-257"></div>
    </section>;
}